//import store from '@/store'
import env from 'env'

const getters = {
    env: state => env,
    trans: state => state.app.data ? state.app.data.trans : [],
    route_auth_level(state) {
        return app => {
            return app.$router.currentRoute.meta.auth_level
        }
    },
    route_navbar(state) {
        return app => {
            return app.$router.currentRoute.meta.navbar
        }
    },
    csrf_token(state) {
        return document.getElementsByName('csrf-token')[0].content
    },
//    route_auth_level: state => this.$router.currentRoute.meta.auth_level,
    auth_check: state => !! state.auth.user,
    auth_id: state => state.auth.user ? state.auth.user.id : null,
    auth_email: state => state.auth.user ? state.auth.user.email : '',
    auth_name: state => state.auth.user ? [ state.auth.user.last_name, state.auth.user.first_name ].join(' ').trim() : '',
    auth_pages: state => state.auth.user ? state.auth.user.pages || [] : [],
    auth_batches: state => state.auth.user ? state.auth.user.batches || {} : {},
    auth_level: state => state.auth.user ? state.auth.user.level : '000',
    auth_level_name: state => {
        if (!state.auth.user) {
            return '000'
        }
        switch (state.auth.user.level) {
            case '000':
                return 'None'
            case '100':
                return 'User'
            case '200':
                return 'Admin'
            default:
                return 'None'
        }
    },
    auth_uuid: state => state.auth.user ? state.auth.user.uuid : '',
    notification_queue: state => state.notification.queue,
    axios_queue: state => state.axios.queue,
    axios_queue_length: state => Object.keys(state.axios.queue).length,
    //  ui_modal_bible_auth: state => state.ui.modal_bible_auth.opened,
    //  verse(state) {
    //    return params => {
    //      if (params.code) {
    //        for (let i = 0; i < store.state.data.current.chapter.verses.length; i++) {
    //          if (params.code === store.state.data.current.chapter.verses[i].code) {
    //            return store.state.data.current.chapter.verses[i]
    //          }
    //        }
    //      }
    //      return null
    //    }
    //  },
}
export default getters


